export default "__VITE_ASSET__DBy9KpBf__"